// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1XCZo","inputWrap":"CustomTip_inputWrap__2ceTC"};